<template>
  <div class="component-vote" :class="{inCMS}" v-if="info.id">
    <div class="loading-panel" v-if="loading">
      <gkLoading color="blue" size="40" loading />
    </div>

    <div class="vote-title">
      {{info.title}} ({{type == 1 ? `多选${limits > 0 ? `，最多选 ${limits} 项` : ''}` : type == 2 ? '单选' : 'PK'}})
    </div>
    <div class="vote-info">
      {{total}} 人已加入 
      <!-- 永久投票 不显示截止时间 -->
      <template v-if="!permanent">
        <span class="dot"></span>
        <template v-if="!isEnd">
          {{info.end_time | formatEndTime(nowTime)}}后截止
        </template>
        <template v-else>
          已截止
        </template>
      </template>
    </div>
    <template v-if="type == 1 || type == 2">
      <div :class="['vote-detail', {submitted: isSubmit, 'is-end': isEnd}]">
        <div class="option-wrap" v-for="item in info.options" :key="item.key">
          <div 
            :class="['option', {'checked': !isSubmit && !isEnd && item.checked, 'self-check': item.checked || isAnswered(item.key)}]" 
            @click="choice(item)">
            <div class="content">
              <span 
                :class="['check', {'checked': !isSubmit && !isEnd && item.checked}, {'mutil': type == 1}, {'radio': type == 2}]"
                v-if="!isEnd && !isSubmit"
              ></span>
              {{item.title}}
            </div>
            <div 
              :class="['result-progress', {'self-check': item.checked || isAnswered(item.key)}]" 
              :style="{width: parseNumber(item.key, true) + '%'}" v-show="isSubmit || isEnd"></div>
          </div>
          <div class="result" v-if="isSubmit || isEnd">
            {{parseNumber(item.key)}} ({{parseNumber(item.key, true)}}%)
          </div>
        </div>
      </div>
      <div class="vote-foot">
        <gkButton class="submit-vote" :disabled="!btnStatus || isSubmit || isEnd" color="blue" size="large" @click="handleSubmit">
          {{isEnd ? '投票已结束' : isSubmit ? '已投票' : '投票'}}
        </gkButton>
        <div class="tip" v-if="!isEnd && !isSubmit">投票后，可查看投票结果</div>
      </div>
    </template>
    <template v-else>
      <div :class="['vote-main', {'is-submit': isSubmit || isEnd}]" v-if="info.options">
        <div 
          :class="['left', {'is-win': isWiner == info.left.key}, {'flat': isFlat}]" 
          @click="handlePK(1)" 
          :style="isSubmit || isEnd ? {width: parseNumber(info.left.key, true) + '%'} : {}">
          <template v-if="!isSubmit && !isEnd">
            <p class="default">投票 <span class="pointer"></span></p>
          </template>
          <template v-else>
            {{parseNumber(info.left.key)}} <span class="mini-text">({{parseNumber(info.left.key, true)}}%)</span>
          </template>
        </div>
        <div class="vs"></div>
        <div 
          :class="['right', {'is-win': isWiner == info.right.key}, {'flat': isFlat}]" 
          @click="handlePK(2)" 
          :style="isSubmit || isEnd ? {width: parseNumber(info.right.key, true) + '%'} : {}">
          <template v-if="!isSubmit && !isEnd">
            <p class="default">投票 <span class="pointer"></span></p>
          </template>
          <template v-else>
            {{parseNumber(info.right.key)}} <span class="mini-text">({{parseNumber(info.right.key, true)}}%)</span>
          </template>
        </div>
        <div class="label left-label" 
          :class="{selected: pkSelected == 1 || isAnswered(info.left.key)}">
          {{info.left.title || ''}}
        </div>
        <div class="label right-label" 
        :class="{selected: pkSelected == 2 || isAnswered(info.right.key)}">
          {{info.right.title || ''}}
        </div>
      </div>
      <div class="tip pk-tip" v-if="!isSubmit && !permanent">
        {{isEnd ? '投票已结束' : '投票后，可查看投票结果'}}
      </div>
    </template>
    
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import {mapState} from 'vuex'

import utils from '../../utils'
import gkButton from 'gkui/button'
import gkLoading from 'gkui/loading'

import VoteService from '../../service/vote.service'
export default {
  name: 'component-vote',
  components: {
    gkButton,
    gkLoading
  },
  props: {
    id: VueTypes.number.def(0),
    aid: VueTypes.string.def(''),
    title: VueTypes.string.def(''),
    inCMS: VueTypes.bool.def(false)
  },
  data () {
    return {
      loading: false,
      isSubmit: false,
      permanent: false, // 是否永久有效的投票，结束年份在2050年以后就是永久的
      info: {},
      selected: [],
      pkSelected: 0, // 1 左边  2 右边
      pkSubmiting: false,
      isEnd: false,
      btnStatus: false,
      limits: 0,
      isFlat: false, // 是否平局
      isWiner: '', // pk 投票获胜一方的key
      total: 0, // 参与投票总人数
      type: 0 // 单选多选类型  1 多选  2 单选 3 pk
    }
  },
  computed: {
    ...mapState(['isMobile', 'nowTime'])
  },
  created () {
    this.loading = true
    this.getVoteInfo()
  },
  filters: {
    formatEndTime (time, nowTime) {
      time = utils.timestamp(time)
      let dist = time - nowTime
      if (dist > 0) {
        let hour = Math.floor(dist / (1000 * 60 * 60))
        if (hour < 1) {
          return Math.floor(dist / (1000 * 60)) + ' 分钟'
        }

        return hour > 24 ? Math.floor(hour / 24) + ' 天' : hour + ' 小时'
      }
    }
  },
  methods: {
    parseNumber (key, percentage = false) {
      if (this.info.statistic) {
        const {statistic} = this.info
        // 分母  多选时 选项占票比例为  选项票数/总投票人数， 单选为  选项票数/总投票数
        let denominator = this.type === 1 ? statistic.reply_user_num : statistic.reply_num
        let cur = statistic.reply_details.find(item => item.key === key)
        if (cur) {
          // return percentage ? (cur.reply_num / denominator).toFixed(2) * 100 : cur.reply_num
          return percentage ? (cur.reply_num / denominator * 100).toFixed(1) : cur.reply_num
        }
      }
      return 0
    },
    /**
     * 处理是否投过票
     */
    isAnswered (key) {
      if (this.info.user_answer) {
        const {user_answer} = this.info
        let cur = user_answer[0].details.find(item => item.key === key)
        if (cur) {
          return true
        }
      }

      return false
    },
    getVoteInfo () {
      VoteService.getVoteById(this.id, this.aid).then(res => {
        // 是否永久投票
        this.permanent = (utils.date(res.end_time, 'YYYY') | 0) >= 2050
        this.loading = false
        this.isEnd = utils.timestamp(res.end_time) < this.nowTime
        this.info = res
        this.type = res.type
        this.limits = Array.isArray(res.limits) && res.limits.length && res.limits[0].body.max_num || 0
        this.total = res.statistic && res.statistic.reply_user_num || 0
        this.isSubmit = !!res.user_answer
        // pk投票 并且结束之后 计算出胜利的一方
        if (this.type === 3 && this.isEnd) {
          if (res.statistic) {
            const {statistic} = res
            let left = statistic.reply_details[0] || {}
            let right = statistic.reply_details[1] || {}
            if ((left.reply_num || 0) > (right.reply_num || 0)) {
              this.isWiner = left.key
            } else if (left.reply_num === right.reply_num) {
              this.isFlat = true
            } else {
              this.isWiner = right.key
            }
            // statistic.reply_details.reduce((pre, item, index) => {
            //   if (pre && pre.reply_num > item.reply_num) {
            //     this.isWiner = pre.key
            //   } else if (pre.reply_num === item.reply_num) {
            //     console.log('平局')
            //     this.isFlat = true
            //   } else {
            //     this.isWiner = item.key
            //   }
            //   return item
            // }, null)
          }
        }
        this.$forceUpdate()
      })
    },
    choice (option) {
      if (this.isEnd || this.isSubmit) {
        return
      }

      let index = this.info.options.findIndex(item => item.key === option.key)
      if (this.type === 1) {
        if (this.limits > 0) {
          let selectedLength = this.info.options.filter(item => item.checked).length
          if (selectedLength < this.limits || this.info.options[index].checked) {
            this.info.options[index].checked = !this.info.options[index].checked
          } else {
            this.$Message.toast({
              message: `最多选择 ${this.limits} 项`
            })
            return
          }
        } else {
          this.info.options[index].checked = !this.info.options[index].checked
        }
      } else {
        this.info.options.forEach(opt => {
          opt.checked = opt.key === option.key
        })
      }

      this.btnStatus = this.info.options.some(item => item.checked === true)
      this.$forceUpdate()
    },
    handleSubmit () {
      const {id, question_id} = this.info
      let options = this.info.options.filter(opt => opt.checked).map(item => {
        return {
          key: item.key,
          value: item.title
        }
      })
      const postData = {
        exam_id: id,
        answers: [
          {
            question_id: question_id,
            options: options
          }
        ]
      }

      this.submit(postData).then(res => {
        if (res.id) {
          this.isSubmit = true
          this.$Message.toast({
            message: '投票成功'
          })
          this.getVoteInfo()
        }
      }).catch((err) => {
        if (err && err.code + '' === '-2000') {
          return
        }

        this.$Message.toast({
          message: err.msg || err.message || '投票失败'
        })
      })
    },
    handlePK (pkSelected) {
      if (this.isSubmit || this.isEnd) {
        return
      }

      // this.pkSubmiting = true
      const {id, question_id, options} = this.info
      const option = {
        key: options[pkSelected - 1].key,
        value: options[pkSelected - 1].title
      }

      const postData = {
        exam_id: id,
        answers: [
          {
            question_id: question_id,
            options: [option]
          }
        ]
      }
      this.submit(postData).then(res => {
        this.pkSelected = pkSelected
        this.isSubmit = true
        // this.pkSubmiting = false
        if (res.id) {
          this.$Message.toast({
            message: '投票成功'
          })
          this.getVoteInfo()
        }
      }).catch(err => {
        if (err && err.code + '' === '-2000') {
          return
        }
        this.$Message.toast({
          message: err.msg || err.message || '投票失败'
        })
      })
    },
    submit (data) {
      return VoteService.submitVote(data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";

.loading-panel {
  position: absolute; top: 0; left: 0; right: 0;z-index: 1;
  height: 190px;
  @extend %center;
  background: #fff;
  border-radius: 10px;
}

.component-vote {
  position: relative;
  box-sizing: border-box;
  width: 100%; min-height: 248px;
  padding: 30px 26px 32px 23px;
  border: 1px solid $borderGray;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px rgba(175, 186, 198, 0.19);

  @include mobile () {
    min-height: auto;
    padding: 29px 13px 32px 13px;
  }

  &.inCMS {
    pointer-events: none;
  }

  & .vote-title {
    @include font(16, 600);
    line-height: 21px;
    word-spacing: 3px;
    color: $lightBlack;
  }

  & .vote-info {
    display: flex;
    align-items: center;
    margin: 9px 0 20px;
    @include lineFont(12, 400);
    color: $gray;

    @include mobile () {
      margin-top: 8px;
    }
  }

  & .dot {
    display: inline-block;
    width: 2px; height: 2px;
    margin: 0 6px;
    background: $gray;
    border-radius: 50%;
    line-height: 12px;
  }

  & .vote-detail {

    & .option-wrap {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      & .result {
        flex-shrink: 0;
        width: 84px;
        text-align: right;
        @include font(14, 400);
        line-height: 34px;
        color: $gray;

        @include mobile () {
          width: 68px;
          font-size: 12px;
        }
      }
    }

    & .content {
      box-sizing: border-box;
      position: absolute; left: 0; top: 0; bottom: 0; z-index: 1;
      @extend %center;
      padding: 0 15px;

      @include mobile () {
        position: relative;
        height: auto;
        padding: 8px 9px;
        line-height: 18px;
      }
    }

    & .option {
      position: relative;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      width: 100%; 
      border: 1px solid #E0E3E5;
      border-radius: 4px;
      @include lineFont(14, 400);
      line-height: 15px;
      color: $gray;
      cursor: pointer;
      overflow: hidden;

      @include web () {
        height: 36px;
      }

      &.checked {
        background: #EBF3FF;
        border-color: #C1D4FB;
      }

      &.self-check {
        border-color: #C1D4FB;

        & .content {
          color: $blue;
        }
      }

      & .result-progress {
        position: absolute; top: 0; left: 0; bottom: 0;
        width: 0%;
        background: #F1F1F1;
        border-radius: 4px 0 0 4px;
        transition: width 1s ease-in-out;

        &.self-check {
          background: #EBF3FF;
        }
      }
    }

    // 投票结束后的选项样式
    &.submitted,
    &.is-end {
      & .option {
        pointer-events: none;
        cursor: not-allowed;
      }
    }

    & .check {
      position: relative;
      box-sizing: border-box;
      flex-shrink: 0;
      width: 16px; height: 16px;
      margin-right: 10px;
      border: 1px solid rgba($color: $gray, $alpha: 0.6);
      @extend %transition;

      @include mobile () {
        top: -1px;
      }

      &.checked {
        background: $blue;

        &:before {
          color: #fff;
          border-color: $blue;
        }
      }

      &:before {
        position: absolute;
        content: '\e67d';
        font-family: 'iconfont';
        color: #fff;
        transform: scale(0.7);

        @include mobile () {
          top: -2px;
        }
      }

      &.mutil {
        border-radius: 4px;
      }

      &.radio {
        border-radius: 50%;
      }
    }
  }

  & .vote-foot {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    & .submit-vote {
      width: 134px;
      border-radius: 40px;
      &[disabled] {
        opacity: 1;
        background: #B3B3B3!important;
      }
    }
  }

  & .vote-main {
    position: relative;
    display: flex;
    width: 528px;
    margin: 50px auto 34px;

    @include mobile () {
      width: 100%;
      margin-top: 20px;
    }

    &.is-submit {
      & .left-label.selected:before,
      & .right-label.selected:after {
        display: inline-block;
      }
    }

    & .pointer {
      display: inline-block;
      width: 11px; height: 14px;
      margin-left: 5px;
      background: url('../../assets/img/talk/pointer.png') no-repeat;
      background-size: 11px 14px;
      transform: translateY(2px);
    }

    & .label {
      position: absolute; bottom: -27px;
      @include font(14, 400);
      line-height: 21px;
      color: $lightBlack;
    }

    & .left-label {
      left: 0;

      &:before {
        content: '已投票';
        display: none;
        width: 60px; height: 21px;
        margin-right: 4px;
        background: #EEF2FE;
        border-radius: 21px;
        line-height: 22px;
        text-align: center;
        @include font(12, 400);
        color: #1458D4;
      }
    }

    & .right-label {
      right: 0;

      &:after {
        content: '已投票';
        display: none;
        width: 60px; height: 21px;
        margin-left: 4px;
        background: #FFF2E6;
        border-radius: 21px;
        line-height: 22px;
        text-align: center;
        @include font(12, 400);
        color: #FF8A00;
      }
    }

    & .left,
    & .right {
      position: relative;
      flex-grow: 1;
      min-width: 80px; height: 36px;
      line-height: 36px;
      text-align: center;
      @include font (14, 400);
      color: #fff;
      cursor: pointer;
      transition: width 1.2s ease-out 0.2s;
      overflow: hidden;

      & .mini-text {
        font-size: 12px;
      }

      &:before {
        content: '';
        position: absolute; z-index: 1; top: 0;
        width: 42px; height: 36px;
        background-image: url('../../assets/img/talk/pk.png');
        background-repeat: no-repeat;
        background-size: 42px 36px;
      }

      &:after {
        display: none;
        content: '';
        position: absolute; z-index: 2; bottom: 0;
        width: 47px; height: 35px;
        background-image: url('../../assets/img/talk/victory.png');
        background-repeat: no-repeat;
        background-size: 47px 35px;

        @include mobile () {
          width: 38px; height: 28px;
          background-size: 38px 28px;
        }
      }
      // 平局
      &.flat:after {
        display: block;
        background-image: url('../../assets/img/talk/flat.png');
        background-repeat: no-repeat;
      }

      &.is-win:after {
        display: block;
      }

      &:hover .default {
        animation: scale-boundce 0.3s ease-in;
      }
    }

    & .left {
      background-color: #527FFF;
      border-radius: 4px 0 0 4px;
      &:before {
        left: 0;
        transform: rotateY(180deg);
      }

      &:after {
        left: 0;
      }
    }

    & .right {
      background-color: #FF8A00;
      border-radius: 0 4px 4px 0;
      &:before {
        right: 0;
      }

      &:after {
        right: 0;
      }
    }

    & .vs {
      flex-shrink: 0;
      width: 60px; height: 36px;
      background: url('../../assets/img/talk/vote-vs.png') no-repeat;
      background-size: 100% 100%;
    }
  }

  & .tip {
    margin-top: 16px;
    text-align: center;
    @include lineFont(12, 400);
    color: $gray;

    &.pk-tip {
      margin-top: 44px;

      @include mobile () {
        margin-top: 40px;
      }
    }
  }
}

</style>
